// 역할 라벨 — 화면 표기 단일 소스(클라 사본).
//
// 서버 정본은 routes/admin-accounts.js 의 ROLE_LABELS 이고, GET /api/admin/meta/roles 가
// 그것을 그대로 내려준다. 다만 그 경로는 운영 관리자(operator) 허용 목록(utils/operatorAccess.js)
// 밖이라 operator 화면에서는 서버 표를 읽을 수 없다. 그래서 같은 표의 사본을 여기 둔다.
//
// ⚠️ 이중 관리 — 서버 ROLE_LABELS / server.js VALID_ROLES 를 고치면 이 파일도 같이 고쳐야 한다.
//    허용 목록에 GET /api/admin/meta/roles 를 추가하면 이 사본을 지우고 서버 응답으로 되돌릴 수 있다.
var ROLE_LABELS = {
  // 2026-09-29 역할 분리: 내부 값 admin = 전체 권한(개발자) → 화면에는 '마스터'.
  //   운영 업무만 하는 새 역할 operator 가 화면상의 '관리자' 다.
  admin: '마스터',
  '관리자': '마스터',
  operator: '관리자',
  user: '사용자',
  doc_agency: '서류대행',
  cancel_agency: '말소대행',
  customs_broker: '관세사',
  carrier: '캐리어',
  shoring: '쇼링장',
  driver: '기사'
};

// server.js VALID_ROLES 와 같은 순서. 드롭다운 항목 생성용.
var ROLE_VALUES = ['admin', 'operator', 'user', 'doc_agency', 'cancel_agency', 'customs_broker', 'carrier', 'shoring', 'driver', '관리자'];

function roleLabel(role) {
  return ROLE_LABELS[role] || role || '';
}

function roleOptions(values) {
  return values.map(function(v) { return { value: v, label: ROLE_LABELS[v] || v }; });
}

// 운영 관리자가 계정에 부여할 수 있는 역할 — admin/관리자/operator 는 뺀다.
//   운영 관리자는 아무 계정의 비밀번호를 초기화할 수 있다(허용 목록). 여기서 admin 을 고를 수 있으면
//   "admin 계정을 만들고 그 비밀번호를 내가 정한다" 로 전체 권한을 얻는다(권한 상승).
//   ⚠️ 이건 화면 차단일 뿐 — 서버 POST /admin/companies/:id/users · PUT /admin/users/:id 는
//      role 값을 제한하지 않는다(utils/accountActions.js addCompanyUser/updateUser). 서버 보강 필요.
var OPERATOR_ASSIGNABLE_ROLES = ['user', 'doc_agency', 'cancel_agency', 'customs_broker', 'carrier', 'shoring', 'driver'];

export { ROLE_LABELS, ROLE_VALUES, roleLabel, roleOptions, OPERATOR_ASSIGNABLE_ROLES };
